import React, { useRef } from 'react';
import CastingRecentEvents from './CastingRecentEvents';
import DsButton from '../../common/DsButton';
import CastingPositionPlane from '../../common/artists/CastingPositionPlane';
import { castingPositionToPlot, castingPositionFromPlot } from '../../../utils/castingPosition';
import type { CastingPosition } from '../../../api/castingReference';
const clamp = (n: number) => Math.max(0, Math.min(1, n));
export default function CastingPositionEditor({ value, disabled, onChange, genreId, eventId }: {
  genreId?: number; eventId?: string;
  value?: CastingPosition | null; disabled?: boolean; onChange: (position: CastingPosition | null) => void;
}) {
  const plot = value ? castingPositionToPlot(value) : null;
  const drag = useRef<{ x: number; y: number } | null>(null);
  const move = (e: React.PointerEvent<HTMLDivElement>) => {
    if (!drag.current || disabled) return;
    const rect = e.currentTarget.getBoundingClientRect();
    onChange(castingPositionFromPlot((e.clientX - rect.left - drag.current.x) / rect.width, (e.clientY - rect.top - drag.current.y) / rect.height));
  };
  return <div className="casting-position-editor">
    <CastingRecentEvents genreId={genreId} eventId={eventId}>{points => <CastingPositionPlane><div className="casting-position-editor__target" data-testid="casting-position-input"
      onPointerDown={e => {
        if (disabled || e.button !== 0) return;
        const rect = e.currentTarget.getBoundingClientRect();
        const handle = (e.target as HTMLElement).closest('[data-position-handle]');
        drag.current = handle && plot ? { x: e.clientX - rect.left - plot.left * rect.width, y: e.clientY - rect.top - plot.top * rect.height } : { x: 0, y: 0 };
        e.currentTarget.setPointerCapture(e.pointerId); move(e);
      }} onPointerMove={move} onPointerUp={e => { move(e); drag.current = null; }} onPointerCancel={() => { drag.current = null; }}>
      {value ? <DsButton variant="secondary" data-position-handle className="casting-position-editor__handle" disabled={disabled}
        style={{ left: `${plot!.left * 100}%`, top: `${plot!.top * 100}%` }}
        aria-label={`公演の位置：難易度${(value.x * 100).toFixed(1)}、ジャンル傾向${(value.y * 100).toFixed(1)}。矢印キーで移動`}
        onKeyDown={(e: React.KeyboardEvent) => {
          if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(e.key)) return;
          e.preventDefault(); const step = e.shiftKey ? 0.05 : 0.005;
          onChange({ x: clamp(value.x + (e.key === 'ArrowUp' ? step : e.key === 'ArrowDown' ? -step : 0)), y: clamp(value.y + (e.key === 'ArrowRight' ? step : e.key === 'ArrowLeft' ? -step : 0)) });
        }}>●</DsButton> : <span className="casting-position-editor__placeholder">タップして公演を配置</span>}
    </div>{points}</CastingPositionPlane>}</CastingRecentEvents>
    <p className="form-hint">点をドラッグして自由に設定できます。設定後に保存すると反映されます。</p>
    {value && <><label>演奏難易度（易 → 難）<input aria-label="演奏難易度の位置" type="range" min="0" max="1" step="0.001" value={value.x} disabled={disabled} onChange={e => onChange({ ...value, x: Number(e.target.value) })} /></label>
      <label>ジャンル傾向（ポップス → クラシック）<input aria-label="ジャンル傾向の位置" type="range" min="0" max="1" step="0.001" value={value.y} disabled={disabled} onChange={e => onChange({ ...value, y: Number(e.target.value) })} /></label></>}
    <DsButton variant="secondary" disabled={disabled} onClick={() => onChange(value ? null : { x: 0.5, y: 0.5 })}>{value ? '配置を解除' : '中央に配置して調整'}</DsButton>
  </div>;
}
